export const legacyAccessPath = '/my/access.phtml'
export const legacyGdprPath = '/gdpr_data_download_instruction_webview'
